import { render, staticRenderFns } from "./PartsView.vue?vue&type=template&id=6feb6d74&scoped=true&"
import script from "./PartsView.vue?vue&type=script&lang=js&"
export * from "./PartsView.vue?vue&type=script&lang=js&"
import style0 from "./PartsView.vue?vue&type=style&index=0&id=6feb6d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb6d74",
  null
  
)

export default component.exports